import React, { useState, useEffect } from "react";
import { FileUploader } from "react-drag-drop-files";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { CloseIcon } from "../../Static/icons/iconshere";
import Progress from "react-progressbar";
import Releases from "../Releases/releases";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import moment from "moment";
import { usePageTitle } from "../PageTitleContext";
import { FormControl, RadioGroup, Radio, FormControlLabel } from "@mui/material";
import { BtnLoading } from "../../animations/BtnLoading";
import { debounce } from "../../utils/useWindowDimensions";
import apiClient from "../../apiClient";
import {
  XR_ALL_ASSET_VERSIONS,
  XR_ASSET_VERSION_CREATE,
  XR_ASSET_VERSION_LIST,
  XR_MODULE_PUBLISH,
} from "../../apiClient/apiEndpoints";
import { resourceAssetKeyType, resourceAssetType, resourcePlatforms } from "../utils";
import { toastError } from "../../utils/toast";
import { getAllowedMaxFileSize, isFileSizeOverMaxSize } from "../../utils/common";
import { MODULE_ASSET_SIZE } from "../../constant/limitSize";

let emptyFile = resourcePlatforms.reduce((acc, platform) => {
  acc[platform.key] = {
    file: platform.file,
    url: platform.url,
    comment: platform.comment,
    assetType: platform.assetType,
    embedLink: platform.embedLink,
    progress: platform.progress,
    error: platform.error,
    isForceUpdated: platform.isForceUpdated,
  };
  return acc;
}, {});

function UploadAssets() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const locationData = useLocation();
  const { actionMode, type, name } = locationData?.state;
  if (!actionMode || !type) navigate("/dashboard/xr");
  const { setPageTitle } = usePageTitle();
  const moduleUUID = params?.uuid;
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const moduleSlice = useSelector((state) => state.moduleSlice);
  const [loading, setLoading] = useState(false);
  const [publishLoading, setPublishLoading] = useState(false);
  const [reviewUploadFile, setReviewUploadFile] = useState(emptyFile);
  const [versionList, setVersionList] = useState([]);
  const [vaultHistoryList, setVaultHistoryList] = useState(null);
  const [showVaultHistory, setShowVaultHistory] = useState(false);
  const [publishError, setPublishError] = useState(null);
  const [availablePlatformList, setAvailablePlatformList] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState("standalonevr");

  const fileTypes = ["*"];

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  const getAssetAvailablePlatformList = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${XR_ALL_ASSET_VERSIONS}/${moduleUUID}`);
      let availablePlatform = data.availablePlatform;
      setAvailablePlatformList(availablePlatform);
      setVaultHistoryList(data.list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setPageTitle("XR Modules");
    if (actionMode === "REVIEW") getAssetAvailablePlatformList();
  }, [locationData]);

  const getModuleVersionList = async () => {
    setVersionList([]);
    try {
      let data = await apiClient.get(
        `${configData.config.UNO_URL}${XR_ASSET_VERSION_LIST}/${selectedPlatform}/${moduleUUID}`
      );
      setVersionList(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getModuleVersionList();
  }, [selectedPlatform]);

  const handleChangeUploadFile = (file) => {

    if (selectedPlatform === "web" && isFileSizeOverMaxSize(file?.size, MODULE_ASSET_SIZE )) {
      setReviewUploadFile((preState) => ({
        ...preState,
        [selectedPlatform]: {
          ...preState[selectedPlatform],
          progress: 0,
          url: null,
          embedLink: null,
          error: `File size should not be greater than ${getAllowedMaxFileSize(MODULE_ASSET_SIZE)}`,
        },
      }));
      return;
    }
    setReviewUploadFile((preState) => ({
      ...preState,
      [selectedPlatform]: {
        ...preState[selectedPlatform],
        file: file,
        error: null,
      },
    }));

    const formData = new FormData();
    formData.append("file", file);

    axios
      .post(`${configData.config.UNO_URL}/api/resource/asset/upload/${selectedPlatform}/${moduleUUID}`, formData, {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          let progress = (progressEvent.loaded / progressEvent.total) * 100;
          if (progress < 100) {
            setReviewUploadFile((preState) => ({
              ...preState,
              [selectedPlatform]: {
                ...preState[selectedPlatform],
                progress: Math.floor(progress),
              },
            }));
          }
        },
      })
      .then((res) => {
        setReviewUploadFile((preState) => ({
          ...preState,
          [selectedPlatform]: {
            ...preState[selectedPlatform],
            progress: 100,
            url: res.data.url,
            embedLink: res.data.embedLink,
          },
        }));
      })
      .catch((err) => {
        console.log(err);
        setReviewUploadFile((preState) => ({
          ...preState,
          [selectedPlatform]: {
            ...preState[selectedPlatform],
            progress: 0,
            url: null,
            embedLink: null,
            error: "Error in file upload. try again",
          },
        }));
      });
  };

  const handleToggleForceUpdate = (value) =>{
      setReviewUploadFile((preState) => ({
        ...preState,
        [selectedPlatform]: {
          ...preState[selectedPlatform],
          isForceUpdated: value,
        },
      }));
  }

  const handleChangePlatform = (type) => {
    setSelectedPlatform(type);
    if (actionMode === "XR") setReviewUploadFile(emptyFile);
  };

  const handleChangeFileType = (type) => {
    if (actionMode === "XR") {
      setReviewUploadFile({
        ...emptyFile,
        [selectedPlatform]: {
          ...emptyFile[selectedPlatform],
          assetType: type,
        },
      });
    } else {
      setReviewUploadFile((preState) => ({
        ...preState,
        [selectedPlatform]: {
          ...preState[selectedPlatform],
          assetType: type,
        },
      }));
    }
  };

  const uploadModuleAssetFile = async () => {
    try {
      setReviewUploadFile((preState) => ({
        ...preState,
        [selectedPlatform]: {
          ...preState[selectedPlatform],
          error: null,
        },
      }));

      if (!reviewUploadFile[selectedPlatform].url || reviewUploadFile[selectedPlatform].comment.trim().length === 0) {
        setReviewUploadFile((preState) => ({
          ...preState,
          [selectedPlatform]: {
            ...preState[selectedPlatform],
            progress: 0,
            url: null,
            embedLink: null,
            error: "Upload file and fill comment field.",
          },
        }));
        setLoading(false);
        return;
      }

      let data = {
        type: reviewUploadFile[selectedPlatform].assetType,
        platform: selectedPlatform,
        assetLink: reviewUploadFile[selectedPlatform].url,
        embedLink: reviewUploadFile[selectedPlatform].embedLink,
        comment: reviewUploadFile[selectedPlatform].comment,
        isForceUpdated: reviewUploadFile[selectedPlatform].isForceUpdated,
      };

      await apiClient.post(
        `${configData.config.UNO_URL}${XR_ASSET_VERSION_CREATE}/${selectedPlatform}/${moduleUUID}`,
        data
      );
      setReviewUploadFile(emptyFile);
      getModuleVersionList();
      setLoading(false);
    } catch (error) {
      console.log(error);
      setReviewUploadFile(emptyFile);
      setLoading(false);
    }
  };

  const formatSize = (bytes) => {
    if (bytes >= 1048576) {
      return (bytes / 1048576).toFixed(2) + " MB";
    } else if (bytes >= 1024) {
      return (bytes / 1024).toFixed(2) + " KB";
    } else {
      return bytes + " bytes";
    }
  };

  const handlePreTabToJump = () => {
    navigate(`/dashboard/xr/review/details/${moduleUUID}`, {
      state: { name: name, type: type, actionMode: actionMode },
    });
  };

  const setHandleChangeComment = (e) => {
    setReviewUploadFile((preState) => ({
      ...preState,
      [selectedPlatform]: {
        ...preState[selectedPlatform],
        comment: e,
      },
    }));
  };
  const setHandleRemoveFile = () => {
    setReviewUploadFile((preState) => ({
      ...preState,
      [selectedPlatform]: {
        ...preState[selectedPlatform],
        file: null,
        progress: 0,
        url: null,
      },
    }));
  };

  function createFinalObject(data) {
    let result = Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        {
          type: value.assetType,
          platform: key,
          assetLink: value.url,
          embedLink: value.embedLink,
          comment: value.comment,
        },
      ])
    );
    return result;
  }

  const handlePublishProject = async () => {
    try {
      if (publishLoading) return;
      setPublishError(null);
      let basicDetail = moduleSlice?.reviewModuleData?.basicDetail;
      if (!basicDetail) {
        toastError("Something went wrong, try again");
        navigate("/dashboard/xr");
      }

      let platforms = basicDetail.platforms;

      let finalObject = createFinalObject(reviewUploadFile);

      let fileUploadedPlatform = Object.keys(finalObject).filter(
        (item) => finalObject[item].comment.trim().length > 0 && finalObject[item].assetLink
      );
      let _unCompletePlatform = Object.keys(finalObject).filter(
        (item) =>
          (finalObject[item].comment.trim().length > 0 && !finalObject[item].assetLink) ||
          (finalObject[item].comment.trim().length == 0 && finalObject[item].assetLink)
      );

      let checkMatchPlatform = platforms.every((e) => fileUploadedPlatform.includes(e));
      if (!checkMatchPlatform) {
        setPublishError(`Kindly upload files as you select available at platform.`);
        setTimeout(() => {
          setPublishError(null);
        }, 3500);
        toastError("Kindly upload files as you select available at platform");
        return;
      }

      if (_unCompletePlatform.length > 0) {
        setPublishError(
          `${_unCompletePlatform} , These platforms are uncomplete. Kindly complete or remove files and comment.`
        );
        setTimeout(() => {
          setPublishError(null);
        }, 3500);
        toastError(`${_unCompletePlatform} platforms are uncomplete.`);
        return;
      }

      let newBasicDetail = { ...basicDetail };
      newBasicDetail["linkedAssetIds"] = newBasicDetail.linkedAssets.map((e) => e.uuid);
      delete newBasicDetail["platforms"];
      delete newBasicDetail["linkedAssets"];

      let _bodyData = {
        basicDetail: newBasicDetail,
        assetUpload: Object.fromEntries(Object.entries(finalObject).filter(([k]) => fileUploadedPlatform.includes(k))),
      };

      setPublishLoading(true);
      await apiClient.post(`${configData.config.UNO_URL}${XR_MODULE_PUBLISH}/${moduleUUID}`, _bodyData);
      navigate("/dashboard/xr");
    } catch (error) {
      console.log(error);
      setPublishError(error?.response?.data?.message || "Something went wrong.");
      setTimeout(() => {
        setPublishError(null);
      }, 3500);
      toastError(error?.response?.data?.message || "Something went wrong.");
    } finally {
      setPublishLoading(false);
    }
  };

  const debounceHandleSaveReview = debounce(uploadModuleAssetFile, 500, setLoading);
  return (
    <>
      <div className="forassets" data-aos="fade-left">
        <div className="container-fluid">
          <div className="row mt-2">
            <div className="col-md-9">
              <div className="platforupload">
                <div className="popupselect">
                  <p>Platforms</p>
                  <div className="radio-inputs">
                    <FormControl fullWidth className="mb-3 d-flex align-items-start">
                      <RadioGroup
                        row
                        aria-labelledby="price-visibility-label"
                        name="questionType"
                        className="gap-3"
                        value={selectedPlatform}
                        onChange={(e) => handleChangePlatform(e.target.value)}
                      >
                        {resourcePlatforms.map((platform, index) => {
                          return (
                            <FormControlLabel
                              key={index}
                              className="quizlabel"
                              value={platform.key}
                              control={<Radio />}
                              label={platform.name}
                            />
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 d-flex align-items-center justify-content-end">
              <span className="link" onClick={() => setShowVaultHistory(true)}>
                {" "}
                Vault History{" "}
              </span>
            </div>

            <>
              <div className="col-md-6 mt-2">
                <div className="popupselect fortype">
                  <p>Select File Type</p>
                  <div className="radio-inputs">
                    <FormControl fullWidth className="mb-3 d-flex align-items-start">
                      <RadioGroup
                        row
                        aria-labelledby="price-visibility-label"
                        name="questionType"
                        className="gap-3"
                        value={reviewUploadFile[selectedPlatform].assetType}
                        onChange={(e) => handleChangeFileType(e.target.value)}
                      >
                        {resourceAssetType.map((element, index) => {
                          return (
                            <FormControlLabel
                              key={index}
                              className="quizlabel"
                              value={element.key}
                              control={<Radio />}
                              label={element.name}
                            />
                          );
                        })}
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>

                <div className="col-md-12 mt-2">
                  Is Force Update? {" "} 
                  <label className="switch">
                    <input type="checkbox" checked={reviewUploadFile[selectedPlatform].isForceUpdated} onChange={(e)=> handleToggleForceUpdate(e.target.checked)} />
                    <span className="slider round"></span>
                  </label>

                </div>

                <div className="DragDropMenu uploadfilesss mt-3">
                  <div className="fileuploader">
                    <FileUploader
                      handleChange={handleChangeUploadFile}
                      label={"drag & drop or choose file to upload"}
                      name="file"
                    // types={fileTypes}
                    >
                      <span className="upload-box-info"> drag & drop or choose {`${fileTypes}`} file to upload {selectedPlatform === "web" && `(MAX File size ${getAllowedMaxFileSize(MODULE_ASSET_SIZE)})`} </span>
                    </FileUploader>
                  </div>
                </div>

                {reviewUploadFile[selectedPlatform].file && (
                  <div className="uploadstatus">
                    <div className="uploadstatus">
                      {!reviewUploadFile[selectedPlatform].error && (
                        <div className="upperdiv">
                          <div className="uploaddata">
                            <div className="xr">
                              <p>{reviewUploadFile[selectedPlatform].file.name}</p>
                              <p style={{ cursor: "pointer", lineHeight: "1" }} onClick={setHandleRemoveFile}>
                                <i className="bi bi-x-circle-fill"></i>
                              </p>
                            </div>
                            <div className=" xr mb-1">
                              <p className="filesize">{formatSize(reviewUploadFile[selectedPlatform].file.size)} </p>
                              <p className="filesize">{reviewUploadFile[selectedPlatform].progress}%</p>
                            </div>
                            <Progress completed={reviewUploadFile[selectedPlatform].progress} />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <div className="mb-3 mt-2 VComment">
                  <label htmlFor="exampleFormControlTextarea1" className="form-label">
                    Comment{" "}
                  </label>
                  <textarea
                    value={reviewUploadFile[selectedPlatform].comment}
                    onChange={(e) => setHandleChangeComment(e.target.value)}
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                  ></textarea>
                  {reviewUploadFile[selectedPlatform].error && (
                    <div className="uploadProgressBar">
                      <p className="basicDetailError">{reviewUploadFile[selectedPlatform].error}</p>
                    </div>
                  )}
                </div>

                {actionMode !== "REVIEW" && (
                  <div className="deploybtn">
                    <button onClick={debounceHandleSaveReview} className="button">
                      {loading ? <BtnLoading /> : "Upload"}
                    </button>
                  </div>
                )}
              </div>

              <div className="col-md-6 mt-3">
                {actionMode === "REVIEW" && (
                  <>
                    <div className="col-md-12 pe-2 mt-4">
                      <div className="footerbtn text-end">
                        {!publishLoading && <button onClick={handlePreTabToJump}> Back </button>}
                        <button onClick={handlePublishProject}> {publishLoading ? <BtnLoading /> : "Publish"} </button>
                      </div>
                    </div>
                    <div className="col-md-12 pe-2 mt-4">
                      <div className="footerbtn text-end">
                        <p className="errorPublish">{publishError}</p>
                      </div>
                    </div>
                  </>
                )}

                {versionList.length > 0 && (
                  <div className="cardstyle">
                    <div className="deploybtn d-flex justify-content-between">
                      <div>
                        <div className="popupselect fortype">
                          <p className="mb-0">
                            {" "}
                            {versionList[0]?.createdAt ? moment(versionList[0]?.createdAt).fromNow() : null}{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="filedetails">
                      <p>
                        Version :<span>{versionList[0]?.version}</span>
                      </p>
                      <p>
                        Asset :
                        <span>
                          <a href={versionList[0]?.data?.assetLink} download>
                            {
                              versionList[0]?.data?.assetLink?.split("/")[
                              versionList[0]?.data?.assetLink?.split("/")?.length - 1
                              ]
                            }
                          </a>
                        </span>
                      </p>
                      <p>
                        Uploaded By :<span>{versionList[0]?.activities[0]?.users[0]?.name}</span>
                      </p>
                      <p>
                        Timestamp :
                        <span>
                          {versionList[0]?.createdAt
                            ? moment(versionList[0]?.createdAt).format("MMMM Do YYYY, h:mm a")
                            : null}
                        </span>
                      </p>
                      <p>
                        Comment :
                      <span>{versionList[0]?.data?.comment}</span>
                      </p>
                      <p>
                        Is Force Update :
                      <span >{versionList[0]?.data?.isForceUpdated ? "true" : "false"}</span>
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </>

            <>
            </>
          </div>

          <div className="ReleaseHead"> {versionList.length > 0 ? <h1>Releases</h1> : null} </div>

          {versionList?.map((list, index) => {
            return <Releases list={list} key={index + 1} />;
          })}
        </div>
      </div>

      <Modal show={showVaultHistory} onHide={() => setShowVaultHistory(false)} centered size="xl">
        <Modal.Header className="modalheader">
          Version History from Vault
          <span onClick={() => setShowVaultHistory(false)}>
            <CloseIcon />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="current-version">
            <div className="version-table">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Date</th>
                    <th scope="col">File Name</th>
                    <th scope="col">Uploaded by</th>
                    <th scope="col">Version</th>
                    <th scope="col">Comment</th>
                    <th scope="col">Git commit</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {vaultHistoryList &&
                    vaultHistoryList[resourceAssetKeyType[selectedPlatform]] &&
                    vaultHistoryList[resourceAssetKeyType[selectedPlatform]].map((item, index) => {
                      return (
                        <tr key={index + 1}>
                          <td>{index + 1}</td>
                          <td>{moment(item?.createdAt).format("lll") || null}</td>
                          <td>{item?.data?.assetLink?.split("/")?.pop() || null}</td>
                          <td>{item?.activities[0]?.users[0]?.name || null}</td>
                          <td>{item.version}</td>
                          <td>{item?.data?.comment || null}</td>
                          <td>{item?.data?.gitCommit || null}</td>
                          <td>
                            <a className="link" href={item?.data?.assetLink || ""}>
                              View
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UploadAssets;
